<template>
	<a-dropdown :trigger="['click']" :placement="placement">
		<a-input v-model:value="text" type="text" :size="size" :placeholder="placeholder" :loading="loading" :style="{'min-width': '300px'}" @change="search(true)" @focus="search">
			<template #prefix>
				<a-icon type="search" />
			</template>
		</a-input>

		<template #overlay>
			<div class="card air__utils__shadow" :style="{ 'width': `${width}px` }">
				<div class="card-body p-0" :style="{ 'max-height': '380px' }">
					<div :style="{ height: '100%', 'overflow-y': 'auto' }">
						<div class="text-uppercase font-size-12 mb-2 text-gray-6 px-2 pt-2">
							<b>Resultados:</b> ({{ deals.total }})
						</div>
						<template v-if="!loading">
							<ul v-if="deals.results.length > 0" class="list-unstyled mb-0">
								<li v-for="(d,i) in deals.results" v-show="!isHidden[i]" :key="d.id" class="p-2" :class="$style.item">
									<div class="pointer d-flex flex-row align-items-center" @click="select(d)">
										<div class="mr-2">
											<a-avatar :src="images().deal(d,100)" shape="square" />
										</div>
										<div class="overflow-hidden w-100">
											<div class="text-blue text-truncate">
												{{ d.name }}
											</div>
											<div class="text-muted d-flex justify-content-between">
												<span>#{{ d.id }}</span>

												<span class="ml-auto">{{ $moment(d.created_at).fromNow() }}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
							<ghost-message v-else class="py-4" animated="tada" infinite :icon="['fad','ghost']" :text="'Sin resultados'" />
						</template>
						<div v-else class="py-4">
							<ghost-message animated="pulse" infinite :icon="['fad','heartbeat']" :text="'Cargando'" />
						</div>
					</div>
				</div>
			</div>
		</template>
	</a-dropdown>
</template>

<script>
import _ from 'lodash';

export default {
	name: 'DealSearch',
	props: {
		placeholder: {
			type: String,
			default: 'Buscar...',
		},
		size: {
			type: String,
			default: null,
		},
		placement: {
			type: String,
			default: 'bottomRight',
		},
		width: {
			type: Number,
			default: 330,
		},
		hideSelected: {
			type: Array,
			default: () => [],
		},
	},
	emits: ['select'],
	data() {
		return {
			text: '',
			deals: {
				results: [],
				total: 0,
			},
			limit: 6,
			loading: false,
		};
	},
	computed: {
		isHidden() {
			return this.deals.results.map(d => this.hideSelected.includes(d.id));
		},
	},
	methods: {
		search: _.debounce(async function (force) {
			if (force || this.deals.results.length === 0) {
				this.loading = true;
				this.deals = { results: [], total: 0 };
				this.$store.commit('REQUEST_SILENT', true);
				try {
					if (isNaN(parseInt(this.text, 10))) {
						const results = await this.$sdk.deals().list({ offset: 0, search: this.text, limit: this.limit, see_future: 1, order_by: 'date' });
						if (results.ok) this.deals = results.data;
					} else {
						const results = await this.$sdk.deals().get(this.text);
						if (results.ok) this.deals = { results: [results.data], total: 1 };
					}
				} catch (e) { /* silent — axios interceptor already handled */ } finally {
					this.$store.commit('REQUEST_SILENT', false);
					this.loading = false;
				}
			}
		}, 300),
		select(d) {
			this.$emit('select', d);
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
